import type { LayerSpec } from '@/core/pipeline';

type PosterizeParams = { levels: number };

export const posterizeSpec: LayerSpec = {
  kind: 'posterize',
  category: 'filter',
  animated: false,
  label: 'Posterize',
  defaults: { levels: 4 } satisfies PosterizeParams,
  schema: {
    levels: { type: 'int', label: 'Levels', min: 2, max: 16, step: 1, default: 4 },
  },
  run: (input, params) => {
    if (!input) return new ImageData(1, 1);
    const p = params as PosterizeParams;
    const L = Math.max(2, Math.floor(p.levels));
    const out = new ImageData(input.width, input.height);
    const src = input.data;
    const dst = out.data;
    for (let i = 0; i < src.length; i += 4) {
      dst[i]     = Math.round((Math.round(((src[i]     as number) / 255) * (L - 1)) * 255) / (L - 1));
      dst[i + 1] = Math.round((Math.round(((src[i + 1] as number) / 255) * (L - 1)) * 255) / (L - 1));
      dst[i + 2] = Math.round((Math.round(((src[i + 2] as number) / 255) * (L - 1)) * 255) / (L - 1));
      dst[i + 3] = src[i + 3] as number;
    }
    return out;
  },
};
